function Button({ title, type, disabled, className = '' }) {
	return (
		<button
			type={type}
			disabled={disabled}
			className={`font-general-medium px-6 py-2.5 text-white text-center font-medium tracking-wider bg-indigo-500 hover:bg-indigo-600 focus:ring-2 focus:ring-indigo-900 focus:outline-none rounded-lg duration-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
		>
			{title}
		</button>
	);
}

export default Button;
